var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLcAutoavaliacao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "current"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_4437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59999 14.8C8.93599 14.8 8.39999 15.336 8.39999 16C8.39999 16.664 8.93599 17.2 9.59999 17.2C10.264 17.2 10.8 16.664 10.8 16C10.8 15.336 10.264 14.8 9.59999 14.8ZM9.59999 10C8.93599 10 8.39999 10.536 8.39999 11.2C8.39999 11.864 8.93599 12.4 9.59999 12.4C10.264 12.4 10.8 11.864 10.8 11.2C10.8 10.536 10.264 10 9.59999 10ZM9.59999 19.6C8.93599 19.6 8.39999 20.144 8.39999 20.8C8.39999 21.456 8.94399 22 9.59999 22C10.256 22 10.8 21.456 10.8 20.8C10.8 20.144 10.264 19.6 9.59999 19.6ZM12 21.6H23.2V20H12V21.6ZM12 16.8H23.2V15.2H12V16.8ZM12 10.4V12H17.6H23.2V10.4H12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_4437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(6.39999 6.3999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcAutoavaliacao);
export default __webpack_public_path__ + "static/media/lcAutoavaliacao.9ab29369.svg";
export { ForwardRef as ReactComponent };